import { useState } from "react";
import { reviews, faqItems } from "@/mocks/content";

export default function ReviewsFaq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="bg-background-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-2 lg:gap-12">
        {/* 口碑 */}
        <div id="review">
          <p className="mb-2 text-xs font-medium uppercase tracking-widest text-accent-600">Sweet Reviews</p>
          <h2 className="mb-8 font-display text-3xl text-foreground-950 md:text-4xl">吃瓜群众都怎么说</h2>
          <div className="flex flex-col gap-4">
            {reviews.map((r) => (
              <figure key={r.id} className="rounded-2xl border border-background-200 bg-white p-5">
                <div className="mb-3 flex items-center gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="text-sm leading-relaxed text-foreground-700">“{r.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <img src={r.avatar} alt={r.name} title={`${r.name} 的甜系头像`} className="h-10 w-10 rounded-full object-cover" />
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{r.name}</div>
                    <div className="text-xs text-foreground-500">{r.role}</div>
                  </div>
                  <span className="ml-auto flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-700">
                    <i className="ri-heart-3-fill text-[10px]"></i>已嗑
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        {/* FAQ */}
        <div id="faq">
          <p className="mb-2 text-xs font-medium uppercase tracking-widest text-accent-600">FAQ</p>
          <h2 className="mb-8 font-display text-3xl text-foreground-950 md:text-4xl">常见问题</h2>
          <div className="flex flex-col gap-3">
            {faqItems.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={i} className="overflow-hidden rounded-2xl border border-background-200 bg-white">
                  <button
                    onClick={() => setOpenIdx(open ? null : i)}
                    aria-expanded={open}
                    className="flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-4 text-left"
                  >
                    <span className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</span>
                    <i
                      className={`ri-add-line text-xl text-primary-500 transition-transform duration-300 ${open ? "rotate-45" : ""}`}
                    ></i>
                  </button>
                  {open && (
                    <div className="border-t border-background-100 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}